import { render, staticRenderFns } from "./BaseInstallPrompt.vue?vue&type=template&id=5e71a6e0&scoped=true"
import script from "./BaseInstallPrompt.vue?vue&type=script&lang=js"
export * from "./BaseInstallPrompt.vue?vue&type=script&lang=js"
import style0 from "./BaseInstallPrompt.vue?vue&type=style&index=0&id=5e71a6e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e71a6e0",
  null
  
)

export default component.exports